import React from 'react';

import { ITimelineItem } from '../../inputs/Timeline/Timeline.model';
import { dateTimeFormat } from '../../../helpers/time';

interface Props {
  conflictRecordIds: Set<string>;
  filteredItems: ITimelineItem[];
}

const RecorderLogsView: React.FC<Props> = ({
  conflictRecordIds,
  filteredItems,
}) => (
  <div style={{ border: '1px solid #333', borderRadius: 8, overflow: 'hidden' }}>
    {filteredItems
      .slice()
      .sort((a, b) => new Date(b.start).valueOf() - new Date(a.start).valueOf())
      .map((item) => (
        <div
          key={`log_${item.id}`}
          style={{ padding: '12px 16px', borderBottom: '1px solid #333', display: 'grid', gridTemplateColumns: '180px 1fr 120px' }}
        >
          <div>{item.start ? dateTimeFormat(item.start) : '-'}</div>
          <div>{item.title}</div>
          <div style={{ textAlign: 'right' }}>
            {conflictRecordIds.has(item.id) ? 'Conflict' : item.status === "0" ? 'Paused' : 'Scheduled'}
          </div>
        </div>
      ))}
    {filteredItems.length === 0 ? <div style={{ padding: 16 }}>No log entries available for the selected filter.</div> : null}
  </div>
);

export default RecorderLogsView;
